import React from "react";
import BaseField from "./BaseField";

/**
 * @class Textarea
 * @extends BaseField
 * @description Textarea field component
 */
export default class Textarea extends BaseField {
  /**
   * @override
   */
  render() {
    const { id, placeholder, validation } = this.Settings;
    return (
      <div className="field">
        {this.renderLabel()}
        <div className="control">
          <textarea
            name={id}
            className="textarea"
            id={id}
            placeholder={placeholder}
            value={this.state.value}
            onChange={this.onChange}
            required={validation.required}
            maxLength={validation.maxlength}
            minLength={validation.minlength}
          />
        </div>
        {this.renderErrors()}
      </div>
    );
  }
}
